module.exports = __webpack_public_path__ + "img/02.dd49b73e.png";